module.exports = __webpack_public_path__ + "media/page-3.30fbc331.mp3";